
















































import Vue from 'vue';
import IRegion from '../../models/region/IRegion';
import { getCurrentRegion } from '../../api/RegionProvider';

interface IData {
    pserverInfo: IRegion|null;
}

export default Vue.extend({
    data(): IData {
        return {
            pserverInfo: null,
        };
    },
    computed: {
        pserverHome(): string {
            return process.env.VUE_APP_STATIC_REGION_HOMEPAGE!;
        },
        pserverDiscord(): string {
            return process.env.VUE_APP_STATIC_REGION_DISCORD!;
        },
        pserverName(): string {
            return (this.pserverInfo && this.pserverInfo.displayNames.default) || '';
        },
        isSkillDetail(): boolean {
            return this.$route.path.startsWith('/skills/')
                && !this.$route.path.toLowerCase().startsWith('/skills/skillsim');
        },
    },
    async mounted() {
        if (process.env.VUE_APP_USE_STATIC_SERVER) {
            this.pserverInfo = await getCurrentRegion();
        }
    },
});
